import { yup } from '@framework/validation';
import { ConditionGroupExpressionSchema } from '../../../schema/expressions/repository/condition-group/ConditionGroupExpressionSchema';
import { IAdvancedRichTextItem } from '../IAdvancedRichText';

const RichTextAdvancedItemSchema: yup.ObjectSchema<IAdvancedRichTextItem> = yup
  .object({
    type: yup.string().oneOf(['text', 'info']).required(),
    text: yup.string().notRequired(),
    rule: ConditionGroupExpressionSchema.notRequired().default(null),
  })
  .noUnknown()
  .required();

/**
 * Schema di validazione per il campo `label` di un widget in sezione modello.
 */
export const RichTextAdvancedSchema = yup
  .array(RichTextAdvancedItemSchema)
  .meta({ rte: true })
  .required();
